<div class="experts-page">

    <!-- Page Header -->
    <div class="experts-header">
        <div class="container">
            <h1 class="header-title">{{ 'experts_page.title' | translate }}</h1>
            <p class="header-subtitle">{{ 'experts_page.subtitle' | translate }}</p>

            <!-- Filter Chips -->
            <div class="filter-chips">
                <button
                    *ngFor="let f of filters"
                    class="btn filter-pill"
                    [class.active]="filter === f.key"
                    (click)="setFilter(f.key)"
                >
                    {{ f.labelKey | translate }}
                </button>
            </div>

            <!-- Stats -->
            <div class="row g-3 mt-4" style="max-width: 500px;">
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">{{ experts.length }}</div>
                        <div class="stat-label">{{ 'experts_page.stat_certified_experts' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">{{ totalConsultations }}</div>
                        <div class="stat-label">{{ 'experts_page.stat_consultations' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">{{ availableCount }}</div>
                        <div class="stat-label">{{ 'experts_page.stat_available_now' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="container experts-content">

        <!-- No Results -->
        <div *ngIf="filteredExperts.length === 0" class="empty-state">
            {{ 'experts_page.no_experts_found' | translate }}
        </div>

        <!-- Experts Grid -->
        <div class="row g-4" *ngIf="filteredExperts.length > 0">
            <div class="col-md-6 col-lg-4" *ngFor="let ex of filteredExperts">
                <div class="expert-card">
                    <div class="d-flex align-items-start gap-3 mb-3">
                        <div class="expert-avatar">{{ ex.initials }}</div>
                        <div class="flex-grow-1 min-width-0">
                            <div class="d-flex align-items-center gap-2">
                                <h3 class="expert-name">{{ ex.name }}</h3>
                                <span class="availability-dot" *ngIf="ex.available" [title]="'experts_page.available_now' | translate"></span>
                            </div>
                            <div class="expert-role">{{ ex.roleKey | translate }}</div>
                            <div class="expert-specialty">
                                {{ categoryLabelKey(ex.category) | translate }} — {{ ex.specialtyDetailKey | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="expert-details">
                        <div>{{ ex.flag }} {{ ex.location }}, {{ ex.countryKey | translate }}</div>
                        <div>🎓 {{ 'experts_page.years_experience' | translate: { count: ex.experienceYears } }}</div>
                        <div>
                            🗣️
                            <span *ngFor="let lk of ex.languageKeys; let last = last">{{ lk | translate }}{{ last ? '' : ', ' }}</span>
                        </div>
                        <div class="d-flex align-items-center gap-1">
                            <span class="expert-rating">★ {{ ex.rating }}</span>
                            <span>· {{ 'experts_page.consultations_count' | translate: { count: ex.consultations } }}</span>
                        </div>
                    </div>

                    <div class="row g-2 mt-auto">
                        <div class="col-6">
                            <button class="btn btn-primary-green btn-sm w-100">
                                <i class="fa fa-comment me-1"></i> {{ 'experts_page.chat' | translate }}
                            </button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-outline-primary-green btn-sm w-100">
                                <i class="fa fa-video me-1"></i> {{ 'experts_page.video_call' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA -->
        <div class="cta-banner">
            <h2 class="cta-title">{{ 'experts_page.cta_title' | translate }}</h2>
            <p class="cta-text">
                {{ 'experts_page.cta_text' | translate }}
            </p>
            <button class="btn btn-primary-green btn-lg">{{ 'experts_page.cta_apply' | translate }}</button>
        </div>

    </div>
</div>